/**
 * Combines multiple styles into a single string.
 * @param styles - An array of style strings to concatenate.
 * @returns The concatenated styles as a single string.
 */
function mergeGlobalObjects(...styles) {
    return styles.join('');
}

export { mergeGlobalObjects };
